import { Pipe, PipeTransform } from '@angular/core';

type DISTANCE_UNIT = 'km' | 'm';

@Pipe({
  name: 'distance',
})
export class DistancePipe implements PipeTransform {
  /**
   *
   * @param value
   * @param unit metric unit ( allowed values are 'km', 'm' )
   * @returns
   */
  transform(value: number, unit: DISTANCE_UNIT): number {
    if (unit === 'km') {
      return Math.round(value * 0.001);
    }

    return Math.round(value);
  }
}
